import OtSolanoCard from '../../components/commons/OtSolanoCard';
import TiltedCard from '../../components/commons/TiltedCard';
import './Contact.css';

export function Contact() {
  return (
    <div className="contact">
      <TiltedCard>
        <OtSolanoCard />
      </TiltedCard>
    </div>
  );
}
